<template>
  <div class="choose-photo-type">
    <h2 class="is-print-hide title-area">
      <span class="main-title">申请处方</span>
    </h2>
    <breadcrumb firstName="申请处方" secondName="拍照上传"></breadcrumb>
    <el-card class="content">
      <div class="photo-types-box">
        <section class="photo-types" v-for="(item, index) in photoTypes" :key="index">
          <h3>{{ item.title }}</h3>
          <p class="desc">{{ item.desc }}</p>
          <el-button type="primary" @click="jump(item.photoType)">
            {{ item.btnText }}
          </el-button>
        </section>
      </div>
    </el-card>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb';
import { PHOTO_TYPE } from '@/lib/constant';

export default {
  name: 'choosePhotoType',
  components: { breadcrumb },
  data() {
    return {
      ...PHOTO_TYPE,
      photoTypes: [
        {
          photoType: PHOTO_TYPE.TAKE,
          title: '拍摄处方（高拍仪）',
          desc: '电脑链接高拍仪拍摄处方笺',
          btnText: '立即拍摄'
        },
        {
          photoType: PHOTO_TYPE.UPLOAD,
          title: '上传处方笺图片',
          desc: '选择本地处方笺图片 宽x高：368x520像素',
          btnText: '立即上传'
        }
      ]
    };
  },
  methods: {
    jump(photoType) {
      this.$router.push(`/chooseConsultType/photoPrescription/${photoType}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.choose-photo-type {
  .content {
    min-height: calc(100vh - 190px);
    padding: 16px;
    /deep/.el-card__body {
      padding: 0;
    }
  }
  .photo-types-box {
    display: flex;
    .photo-types {
      width: 368px;
      margin-left: 16px;
      padding: 22px 24px 17px;
      border-radius: 8px;
      border: 1px solid #ededed;
      color: #242424;
      &:first-child {
        margin-left: 0;
      }
      h3 {
        height: auto;
        font-weight: bold;
        font-size: 16px;
        line-height: 1.2;
      }
      .desc {
        margin: 12px 0 24px;
        font-size: 14px;
        color: #707070;
      }
    }
  }
}
</style>
